import React, {useState, useEffect} from 'react'
import { Styling } from './styled.js'
import parse from 'html-react-parser'
import {GatsbyImage,  getImage} from 'gatsby-plugin-image';
import ContextConsumer from "../../../../layouts/Context"

export default function ImageText({text, alignment, image, gallery}) {
    
    const [theImageIndex, setTheImageIndex ] = useState()
    const theImage = getImage(image.localFile);
    
    
    useEffect(() => {
        gallery?.map((galleryImage, index) => {
            if(galleryImage?.image?.localFile.childImageSharp.gatsbyImageData.images.fallback.src === image.localFile.childImageSharp.gatsbyImageData.images.fallback.src) {
                setTheImageIndex(index)
            }
        })
    }, [gallery]);
    
    
    return (
        <Styling>
            <div className={`alignment alignment-${alignment}`}>
                <div className="text">{parse(text)}</div>
                
                <ContextConsumer>
                    {({ data, set }) => (
                    <div 
                    className="image-wrapper" 
                    key={`gallery_1`} 
                    onClick={() => set({ 
                        menuOpen: !data.menuOpen, 
                        image: image.localFile,
                        imageIndex: theImageIndex,
                        theGallery:gallery,
                    })}
                    >
                        <GatsbyImage image={theImage} className="image" alt={'test'} />
                    </div>
                    )}
                </ContextConsumer>
            </div>
        </Styling>
    )
}
